import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { UnsubscribeComponent } from './components/unsubscribe/unsubscribe/unsubscribe.component';
import { ResubscribePageComponent } from './components/resubscribe-page/resubscribe-page.component';
import { LoaderComponent } from './components/shared/loader/loader.component';

@NgModule({
  bootstrap: [AppComponent],
  declarations: [AppComponent, UnsubscribeComponent, ResubscribePageComponent, LoaderComponent],
  imports: [BrowserModule, HttpClientModule, AppRoutingModule],
  providers: [],
})
export class AppModule {}


